module.exports = __webpack_public_path__ + "create_poster.png?14fc0e467d107fa818e65f330a0129a6";


//////////////////
// WEBPACK FOOTER
// ./src/static/headers/create_poster.png
// module id = 22
// module chunks = 0